import {railsPartialQuery} from '@github-ui/react-core/future/rails-partial-query'
import {pullRequestsAppBuilder} from '../config/app-builder'

export const pullRequestsChecksRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsChecksRoute', {
  path: '/:owner/:repo/pull/:pr_number/checks',
  queries: [
    railsPartialQuery({
      partialName: 'Main',
      queryDeps: ({pathname}) => {
        return {pathname: `${pathname}/partials/checks_partial`}
      },
    }),
  ],
  index: true,
})
